import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from '@/assets/styles/LeftMenu.module.less';
import { LEFT_MENU_ACTIVE_SETTING } from '@/utils/constant/leftMenu';

type menuBlockType = {
  key: string;
  isOpen: boolean;
};

const LeftMenu: React.FC = () => {
  const [activeMenu, setActiveMenu] = useState<Array<menuBlockType>>(LEFT_MENU_ACTIVE_SETTING);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = ( key: string ) => {
    const menuIndex = activeMenu.findIndex( menu => menu.key === key );
    if ( menuIndex !== -1 ) {
      const updatedMenu = [ ...activeMenu ];
      updatedMenu[ menuIndex ].isOpen = !updatedMenu[ menuIndex ].isOpen;
      setActiveMenu( updatedMenu );
      return;
    }
  };

  const isActive = ( key: string ) => {
    return activeMenu.find( menu => menu.key === key )?.isOpen;
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <section className={styles.leftMenuContainer}>
      {/* 移动端菜单按钮 */}
      {isMobileMenuOpen === false && (
        <button
          className={styles.mobileMenuButton}
          onClick={toggleMobileMenu}
          aria-label="打开菜单"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      )}
      {/* 遮罩层 */}
      {isMobileMenuOpen && <div className={styles.overlay} onClick={toggleMobileMenu} />}

      {/* 左侧菜单 */}
      <section className={`${styles.leftMenu} ${isMobileMenuOpen ? styles.open : ''}`}>
        <div className={styles.menuHeader}>
          <h3>导航菜单</h3>
          <button className={styles.closeButton} onClick={toggleMobileMenu} aria-label="关闭菜单">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <ul className={styles.menuList}>
          <li className={styles.menuItem}>
            <div className={styles.menuItemHeader} onClick={() => toggleMenu('study')}>
              <Link to="/study" className={styles.menuLink}>
                学习中心
              </Link>
              <button
                className={`${styles.toggleButton} ${isActive('study') ? styles.open : ''}`}
                aria-label="展开/收起子菜单"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
            </div>
            <ul className={`${ styles.subMenu } ${ isActive( 'study' ) ? styles.open : '' }`}>
              {/*TODO:完成用户真实数据功能后放开*/}
              {/* <li className={styles.subMenuItem}>
                <Link to="/study" className={styles.subMenuLink}>
                  学习统计
                </Link>
              </li> */}
              <li className={styles.subMenuItem}>
                <Link to="/study/history" className={styles.subMenuLink}>
                  查词记录
                </Link>
              </li>
              <li className={styles.subMenuItem}>
                <Link to="/vocabulary" className={styles.subMenuLink}>
                  生词本
                </Link>
              </li>
            </ul>
          </li>
          <li className={styles.menuItem}>
            <div className={styles.menuItemHeader} onClick={() => toggleMenu('profile')}>
              <Link to="/profile" className={styles.menuLink}>
                账号设置
              </Link>
              <button
                className={`${styles.toggleButton} ${isActive('profile') ? styles.open : ''}`}
                aria-label="展开/收起子菜单"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
            </div>
            <ul className={`${styles.subMenu} ${isActive('profile') ? styles.open : ''}`}>
              <li className={styles.subMenuItem}>
                <Link to="/profile" className={styles.subMenuLink}>
                  我的账号
                </Link>
              </li>
            </ul>
          </li>
        </ul>
      </section>
    </section>
  );
};

export default LeftMenu;
